import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import * as KycActions from './kyc.actions';
import KycAPI from './kyc.api';
import { KycActionTypes } from './kyc.model';

export function* handleFetchApplications(action) {
  try {
    const payload = { ...(action.payload || {}) };
    // MUIDataTable pages from 0, the service pages from 1.
    if (payload.page !== undefined && payload.page !== null) {
      payload.page = payload.page + 1;
    }
    const response = yield call(KycAPI.GetApplications, payload);
    yield put(KycActions.fetchKycSuccess(response));
  } catch (e) {
    yield put(KycActions.fetchKycFailure(e));
  }
}

export function* handleFetchDetail(action) {
  try {
    const response = yield call(KycAPI.GetApplication, action.payload);
    yield put(KycActions.fetchKycDetailSuccess(response));
  } catch (e) {
    // HttpHelper has already surfaced the service's message; the dialog just stays empty.
    yield put(KycActions.fetchKycDetailFailure(e));
  }
}

export function* handleTestConnection(action) {
  try {
    const response = yield call(KycAPI.GetProvider, action.payload);
    yield put(KycActions.testConnectionSuccess(response));
  } catch (e) {
    // A transport failure rather than a reported one: the service answers 200 with { ok: false }
    // when the link itself is the problem, so reaching here means the console could not reach the
    // console's own API. HttpHelper has already said so.
    yield put(KycActions.testConnectionFailure(e));
  }
}

export function* KycSaga() {
  yield takeEvery(KycActionTypes.FETCH_KYC_REQUEST, handleFetchApplications);
  // takeLatest: opening a second application while the first is still loading must not leave the
  // slower response painting over the one the admin is actually looking at.
  yield takeLatest(KycActionTypes.FETCH_KYC_DETAIL_REQUEST, handleFetchDetail);
  yield takeLatest(KycActionTypes.TEST_CONNECTION_REQUEST, handleTestConnection);
}
